import { useCallback, useEffect, useState } from 'react';
import { Story } from '../../../../dorian-shared/types/story/Story';
import { api } from '../../../api';
import { sortChapters } from '../../Book/utils';

export function useEpisodes(bookId: number | undefined) {
  const [episodes, setEpisodes] = useState<Story[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchEpisodes = useCallback(() => {
    const abortController = new AbortController();
    setIsLoading(true);

    api.get(`v1/books/${bookId}/chapters/?groupId=1,9&offset=0&limit=200&latest=1&order=updatedAt:asc&analytics=0`, {
      signal: abortController.signal,
    })
      .then((response) => {
        const activeChapters = response.data.chapters.filter((chapter: Story) => !chapter.deleted);
        const sortedChapters = sortChapters(activeChapters);
        setEpisodes(sortedChapters);
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => {
      abortController.abort();
    };
  }, [bookId]);

  useEffect(() => {
    fetchEpisodes();
  }, [fetchEpisodes]);
  return {
    episodes,
    isLoading,
  };
}
